document.addEventListener('DOMContentLoaded', function () {
    const cartButton = document.querySelector('.header__cart-btn');
    const minicartPopup = document.getElementById('minicartPopup');
    const minicartCloseBtn = document.getElementById('minicartCloseBtn');
    const minicartContent = document.getElementById('minicartContent');

    cartButton.addEventListener('click', function () {
        minicartPopup.classList.add('active');
        minicartContent.classList.add('active');
        document.body.style.overflow = 'hidden';
        minicartContent.style.overflowY = 'auto';
    });

    minicartCloseBtn.addEventListener('click', function () {
        minicartPopup.classList.remove('active');
        minicartContent.classList.remove('active');
        document.body.style.overflow = '';
    });

    minicartPopup.addEventListener('click', function (event) {
        if (event.target === minicartPopup) {
            minicartPopup.classList.remove('active');
            minicartContent.classList.remove('active');
            document.body.style.overflow = '';
        }
    });
});
